var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 46V18M52 18V46M32 46V54M32 54C29.7909 54 28 55.7909 28 58C28 60.2091 29.7909 62 32 62C34.2091 62 36 60.2091 36 58C36 55.7909 34.2091 54 32 54ZM8 46H56M10 10H54C55.1046 10 56 10.8954 56 12V16C56 17.1046 55.1046 18 54 18H10C8.89543 18 8 17.1046 8 16V12C8 10.8954 8.89543 10 10 10Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.33d3c5da0da35e81d6e8584e25f99701.svg";
export { ForwardRef as ReactComponent };